import React from "react";

import { closeToast, selectToastData } from "./store";

import { Warning20Filled, CheckmarkCircle20Filled, Dismiss24Regular } from "@fluentui/react-icons";
import { Caption1, Caption1Strong, mergeClasses } from "@fluentui/react-components";

import { useToastStyles } from "./toast.styles";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";

const TOAST_ICON = {
  error: <Warning20Filled />,
  success: <CheckmarkCircle20Filled />,
};

const ToastElement = () => {
  const classes = useToastStyles();

  const dispatch = useAppDispatch();

  const errorStyles = mergeClasses(classes.root, classes.error);
  const successStyles = mergeClasses(classes.root, classes.success);

  const toastInfo = useSelector(selectToastData);

  if (!toastInfo.isOpen) return null;

  return (
    <div className={toastInfo.type === "error" ? errorStyles : successStyles}>
      {TOAST_ICON[toastInfo.type]}
      <div className={classes.info}>
        <Caption1Strong>{toastInfo.title}</Caption1Strong>
        <Caption1>{toastInfo.message}</Caption1>
      </div>
      <Dismiss24Regular onClick={() => dispatch(closeToast())} />
    </div>
  );
};

export default ToastElement;
